// src/main/AssignTenant.js

import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Button,
    Paper,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Chip,
    Grid,
    Slide,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Divider,
    useTheme,
    InputAdornment,
    Menu,
    Tooltip,
    Card,
    CardContent,
    CardActions,
    Tabs,
    Tab,
    Avatar,
    LinearProgress,
    Stack,
    Alert,
    Snackbar,
    FormControlLabel,
    Switch,
    Stepper,
    Step,
    StepLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Breadcrumbs,
    Link,
    Fab,
    Zoom,
    Badge,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
} from '@mui/material';
// Import Timeline components from @mui/lab
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent,
    TimelineOppositeContent,
} from '@mui/lab';

import {
    Delete,
    Search,
    Add as AddIcon,
    Close as CloseIcon,
    Filter as FilterIcon,
    Refresh as RefreshIcon,
    Edit as EditIcon,
    Visibility as ViewIcon,
    Apartment as ApartmentIcon,
    Home as HomeIcon,
    LocationOn,
    Business,
    FormatListNumbered,
    PictureAsPdf,
    TableChart,
    GetApp,
    Print,
    MeetingRoom,
    Build,
    CheckCircle,
    Cancel,
    People,
    AttachMoney,
    TrendingUp,
    TrendingDown,
    MoreVert,
    Dashboard as DashboardIcon,
    List as ListIcon,
    Store as StoreIcon,
    Phone,
    Email,
    Person,
    Assignment,
    Map as MapIcon,
    ViewModule,
    ViewList,
    ExpandMore,
    NavigateNext,
    AddCircleOutline,
    RemoveCircleOutline,
    Warning,
    CheckBox,
    RadioButtonChecked,
    BedroomParent,
    Bathtub,
    SquareFoot,
    Kitchen,
    LocalParking,
    Elevator,
    Security,
    Wifi,
    AcUnit,
    LocalLaundryService,
    Pool,
    EventNote,
    Receipt,
    History,
    MoveToInbox,
    ExitToApp,
    Gavel,
    VerifiedUser,
    CreditCard,
    CalendarToday,
    Description,
    Note,
    AttachFile,
    CloudUpload,
    Key,
    AssignmentInd,
    HowToReg,
    PersonAdd,
    SwapHoriz,
    CheckCircleOutlineOutlined,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import useCustomToast from '../../hooks/useToast';
import {
    APIPropertyList,
    APIApartmentList,
    APIFloorUnitList,
    APITenantList,
    APIAssignmentList,
    APIAssignmentStore,
    APIAssignmentUpdate,
    APIAssignmentDelete,
    APIAssignmentExportExcel,
    APIAssignmentExportPDF,
    APIAssignmentPrint,
    APIAssignmentStats,
    APIAssignmentTerminate,
    APIAssignmentComplete,
    APIAssignmentHistory
} from '../../apiServices/APIs';
import { formatCreatedAtDate, recordsCount, recordsPerPage } from '../../utils/helpers';
import { getUserDetails } from '../../utils/helpers';
import { apiService } from '../../apiServices/ApiService';
import ErrorState from '../../components/ErrorrState';
import LoadingState from '../../components/LoadingState';
import { usePermission } from '../../hooks/usePermission';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AssignTenant = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const showToast = useCustomToast();
    const [updateId, setUpdateId] = useState('');
    const [postStatus, setPostStatus] = useState('ADD');
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [pageState, setPageState] = useState({
        pageData: [],
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(recordsPerPage);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [viewMode, setViewMode] = useState('list');
    const [statistics, setStatistics] = useState(null);
    const [properties, setProperties] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [availableProperties, setAvailableProperties] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [terminateDialogOpen, setTerminateDialogOpen] = useState(false);
    const [completeDialogOpen, setCompleteDialogOpen] = useState(false);
    const [terminationReason, setTerminationReason] = useState('');
    const [assignmentHistory, setAssignmentHistory] = useState([]);

    // Form data for Assignment
    const [formData, setFormData] = useState({
        tenant_id: '',
        property_id: '',
        move_in_date: '',
        agreed_rent_amount: '',
        security_deposit_paid: false,
        deposit_amount: '',
        assignment_status: 'active',
        notes: '',
        termination_date: '',
        termination_reason: ''
    });

    const [filters, setFilters] = useState({
        assignment_status: '',
        property_id: '',
        tenant_id: '',
        date_from: '',
        date_to: ''
    });

    const [errors, setErrors] = useState({
        tenant_id: false,
        property_id: false,
        agreed_rent_amount: false,
        move_in_date: false
    });

    // Assignment status options
    const assignmentStatusOptions = [
        { id: 'active', name: 'Active', color: 'success', icon: <VerifiedUser /> },
        { id: 'terminated', name: 'Terminated', color: 'error', icon: <Gavel /> },
        { id: 'completed', name: 'Completed', color: 'info', icon: <CheckCircleOutlineOutlined /> }
    ];

    // State for dialogs
    const [filterOptions, setFilterOptions] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    // Use the updated permission hook
    const { hasPermission, loading: permissionLoading } = usePermission();

    useEffect(() => {
        apiService.setToastFunction(showToast);
        fetchProperties();
        fetchTenants();
        fetchAssignments();
        fetchStatistics();
    }, [showToast]);

    // Fetch properties for dropdown
    const fetchProperties = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIPropertyList);
            if (result.success) {
                setProperties(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching properties:", error);
        }
    };

    // Fetch tenants (only active tenants without active assignments)
    const fetchTenants = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APITenantList, { tenant_status: 'active' });
            if (result.success) {
                const allTenants = Array.isArray(result.data) ? result.data : [];
                // Filter tenants without active assignments
                const tenantsWithoutActiveAssignment = allTenants.filter(tenant => 
                    !tenant.assigned_property_id || tenant.tenant_status !== 'active'
                );
                setTenants(tenantsWithoutActiveAssignment);
            }
        } catch (error) {
            console.error("Error fetching tenants:", error);
            setTenants([]);
        }
    };

    // Fetch available properties (properties with available units)
    const fetchAvailableProperties = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIPropertyList, { has_vacant_units: true });
            if (result.success) {
                setAvailableProperties(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching available properties:", error);
            setAvailableProperties([]);
        }
    };

    // Fetch assignment history
    const fetchAssignmentHistory = async (assignmentId) => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIAssignmentHistory, { assignment_id: assignmentId });
            if (result.success) {
                setAssignmentHistory(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching assignment history:", error);
            setAssignmentHistory([]);
        }
    };

    // Fetch assignments
    const fetchAssignments = async () => {
        setLoading(true);
        setError(null);

        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIAssignmentList);

            if (result.success) {
                const assignments = Array.isArray(result.data) ? result.data.reverse() : [];
                setPageState(prev => ({
                    ...prev,
                    pageData: assignments
                }));
            } else {
                setError(result.message);
            }
        } catch (error) {
            setError("Failed to load data");
            console.error("Fetch error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch statistics
    const fetchStatistics = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.listStats(userBranchId, APIAssignmentStats);
            if (result.success && result.data) {
                setStatistics(result.data);
            }
        } catch (error) {
            console.error("Error fetching statistics:", error);
        }
    };

    // Export handlers
    const handleExportClick = (event) => { setExportAnchorEl(event.currentTarget); };
    const handleExportClose = () => { setExportAnchorEl(null); };
    
    const handlePrint = async (record) => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to print assignment details", "error");
            return;
        }
        
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('print_id', record.id);
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.print(APIAssignmentPrint, formDataToSend);

            if (result && result.success) {
                showToast("Success", "PDF file generated successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to generate PDF file", "error");
            }
        } catch (error) {
            console.error("Print error:", error);
            showToast("Error", "Failed to generate PDF file", "error");
        }
    };
    
    const handleExportExcel = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export assignment data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing Excel export...", "info");
            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToExcel(APIAssignmentExportExcel, formDataToSend);
            if (result && result.success) {
                showToast("Success", "Excel file downloaded successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to export Excel file", "error");
            }
        } catch (error) {
            console.error('Excel export error:', error);
            showToast("Error", error.message || "Failed to export Excel file", "error");
        }
    };

    const handleExportPDF = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export assignment data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing PDF export...", "info");

            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToPDF(APIAssignmentExportPDF, formDataToSend);

            if (result && result.success) {
                showToast("Success", "PDF file downloaded successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to export PDF file", "error");
            }
        } catch (error) {
            console.error('PDF export error:', error);
            showToast("Error", error.message || "Failed to export PDF file", "error");
        }
    };

    // Filter based on search term and filters
    const filteredData = pageState.pageData.filter(record => {
        const matchesSearch = searchTerm === '' ||
            record.tenant_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            record.property_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            record.tenant_phone?.includes(searchTerm) ||
            record.assignment_id?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = !filters.assignment_status || 
            record.assignment_status === filters.assignment_status;

        const matchesProperty = !filters.property_id || 
            record.property_id?.toString() === filters.property_id;

        const matchesTenant = !filters.tenant_id || 
            record.tenant_id?.toString() === filters.tenant_id;

        let matchesDate = true;
        if (filters.date_from && record.move_in_date) {
            matchesDate = matchesDate && record.move_in_date >= filters.date_from;
        }
        if (filters.date_to && record.move_in_date) {
            matchesDate = matchesDate && record.move_in_date <= filters.date_to;
        }

        return matchesSearch && matchesStatus && matchesProperty && 
               matchesTenant && matchesDate;
    });

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Dialog handlers
    const handlefilterOptions = () => setFilterOptions(true);
    const handleCloseOptions = () => setFilterOptions(false);

    const handleOpenAdd = () => {
        if (!hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to create assignments", "error");
            return;
        }

        setPostStatus("ADD");
        setFormData({
            tenant_id: '',
            property_id: '',
            move_in_date: new Date().toISOString().split('T')[0],
            agreed_rent_amount: '',
            security_deposit_paid: false,
            deposit_amount: '',
            assignment_status: 'active',
            notes: '',
            termination_date: '',
            termination_reason: ''
        });
        setErrors({
            tenant_id: false,
            property_id: false,
            agreed_rent_amount: false,
            move_in_date: false
        });
        fetchAvailableProperties();
        fetchTenants();
        setOpenAdd(true);
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
    };

    const handleOpenView = async (record) => {
        setSelectedRecord(record);
        await fetchAssignmentHistory(record.id);
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
        setAssignmentHistory([]);
    };

    const handleOpenEdit = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to edit assignments", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("UPDATE");

        setFormData({
            tenant_id: record.tenant_id || '',
            property_id: record.property_id || '',
            move_in_date: record.move_in_date || '',
            agreed_rent_amount: record.agreed_rent_amount || '',
            security_deposit_paid: record.security_deposit_paid || false,
            deposit_amount: record.deposit_amount || '',
            assignment_status: record.assignment_status || 'active',
            notes: record.notes || '',
            termination_date: record.termination_date || '',
            termination_reason: record.termination_reason || ''
        });
        fetchAvailableProperties();
        fetchTenants();
        setOpenAdd(true);
    };

    const handleOpenDelete = (record) => {
        if (!hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete assignments", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("DELETE");
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    const handleOpenTerminate = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to terminate assignments", "error");
            return;
        }
        setSelectedRecord(record);
        setTerminationReason('');
        setTerminateDialogOpen(true);
    };

    const handleCloseTerminate = () => {
        setTerminateDialogOpen(false);
    };

    const handleOpenComplete = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to complete assignments", "error");
            return;
        }
        setSelectedRecord(record);
        setCompleteDialogOpen(true);
    };

    const handleCloseComplete = () => {
        setCompleteDialogOpen(false);
    };

    // Form handlers
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setErrors(prev => ({
            ...prev,
            [name]: false
        }));

        if (name === 'tenant_id') {
            const selectedTenant = tenants.find(t => t.id.toString() === value);
            if (selectedTenant && !formData.agreed_rent_amount) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value,
                    agreed_rent_amount: selectedTenant.monthly_rent || ''
                }));
                return;
            }
        }

        if (name === 'property_id') {
            const selectedProperty = availableProperties.find(p => p.id.toString() === value);
            if (selectedProperty && !formData.agreed_rent_amount) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value,
                    agreed_rent_amount: selectedProperty.default_rent_amount || prev.agreed_rent_amount
                }));
                return;
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Filter handlers
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            assignment_status: '',
            property_id: '',
            tenant_id: '',
            date_from: '',
            date_to: ''
        });
        setSearchTerm('');
        setSelectedProperty('');
        handleCloseOptions();
    };

    const applyFilters = () => {
        handleCloseOptions();
    };

    const validateForm = () => {
        if (!formData.tenant_id) {
            showToast("Validation Error", "Please select a tenant", "warning");
            return false;
        }
        if (!formData.property_id) {
            showToast("Validation Error", "Please select a property", "warning");
            return false;
        }
        if (!formData.move_in_date) {
            showToast("Validation Error", "Move-in date is required", "warning");
            return false;
        }
        if (!formData.agreed_rent_amount || formData.agreed_rent_amount <= 0) {
            showToast("Validation Error", "Agreed rent amount is required and must be greater than 0", "warning");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (postStatus === "ADD" && !hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to create assignments", "error");
            return;
        }
        
        if (postStatus === "UPDATE" && !hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update assignments", "error");
            return;
        }
        
        if (postStatus === "DELETE" && !hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete assignments", "error");
            return;
        }
        
        if (postStatus !== "DELETE") {
            if (!validateForm()) return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));

        if (postStatus !== "DELETE") {
            formDataToSend.append('tenant_id', formData.tenant_id);
            formDataToSend.append('property_id', formData.property_id);
            formDataToSend.append('move_in_date', formData.move_in_date);
            formDataToSend.append('agreed_rent_amount', formData.agreed_rent_amount);
            formDataToSend.append('security_deposit_paid', formData.security_deposit_paid ? 1 : 0);
            formDataToSend.append('deposit_amount', formData.deposit_amount || 0);
            formDataToSend.append('assignment_status', formData.assignment_status);
            formDataToSend.append('notes', formData.notes || '');
        }

        if (postStatus === "UPDATE" || postStatus === "DELETE") {
            formDataToSend.append('updateId', updateId);
        }

        try {
            let result;
            if (postStatus === "ADD") {
                result = await apiService.create(APIAssignmentStore, formDataToSend);
            } else if (postStatus === "UPDATE") {
                result = await apiService.update(APIAssignmentUpdate, formDataToSend);
            } else if (postStatus === "DELETE") {
                result = await apiService.delete(APIAssignmentDelete, formDataToSend);
            }

            if (result && result.success) {
                showToast("Success", result.message, "success");
                handleCloseAdd();
                handleCloseDelete();
                fetchAssignments();
                fetchStatistics();
                fetchTenants();
                fetchAvailableProperties();
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const handleTerminateAssignment = async () => {
        if (!terminationReason) {
            showToast("Validation Error", "Please provide a termination reason", "warning");
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));
        formDataToSend.append('assignment_id', selectedRecord.id);
        formDataToSend.append('termination_reason', terminationReason);

        try {
            const result = await apiService.create(APIAssignmentTerminate, formDataToSend);
            if (result && result.success) {
                showToast("Success", result.message, "success");
                handleCloseTerminate();
                fetchAssignments();
                fetchStatistics();
                fetchTenants();
                fetchAvailableProperties();
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const handleCompleteAssignment = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));
        formDataToSend.append('assignment_id', selectedRecord.id);

        try {
            const result = await apiService.create(APIAssignmentComplete, formDataToSend);
            if (result && result.success) {
                showToast("Success", result.message, "success");
                handleCloseComplete();
                fetchAssignments();
                fetchStatistics();
                fetchTenants();
                fetchAvailableProperties();
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const getStatusColor = (status) => {
        const statusMap = {
            'active': 'success',
            'terminated': 'error',
            'completed': 'info'
        };
        return statusMap[status] || 'default';
    };

    const getStatusIcon = (status) => {
        const statusMap = {
            'active': <VerifiedUser />,
            'terminated': <Gavel />,
            'completed': <CheckCircleOutlineOutlined />
        };
        return statusMap[status] || <Assignment />;
    };

    const getStatusText = (status) => {
        const option = assignmentStatusOptions.find(opt => opt.id === status);
        return option ? option.name : status;
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-UG', {
            style: 'currency',
            currency: 'UGX',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    if (permissionLoading) {
        return <LoadingState message="Loading permissions..." variant="medical" size="large" fullPage />;
    }

    if (loading) {
        return (
            <LoadingState
                message="Loading Assignment Data..."
                variant="medical"
                size="large"
                fullPage
            />
        );
    }

    if (error) {
        return (
            <ErrorState
                error={error}
                onRetry={fetchAssignments}
                title="Unable to Load Assignment Data"
                variant="medical"
                fullPage
                retryText="Retry Loading"
            />
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            {/* Statistics Cards */}
            {statistics && (
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Total Assignments</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                                        {statistics.total_assignments || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.primary.light, width: 56, height: 56 }}>
                                    <AssignmentInd sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Active Assignments</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                        {statistics.active_assignments || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.success.light, width: 56, height: 56 }}>
                                    <VerifiedUser sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Total Deposits</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.warning.main }}>
                                        {formatCurrency(statistics.total_deposits || 0)}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.warning.light, width: 56, height: 56 }}>
                                    <CreditCard sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Monthly Revenue</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.info.main }}>
                                        {formatCurrency(statistics.total_monthly_revenue || 0)}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.info.light, width: 56, height: 56 }}>
                                    <AttachMoney sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            )}

            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        color: theme.palette.primary.main,
                        flexShrink: 0
                    }}>
                        Property Assignments ({recordsCount(pageState.pageData.length)} Total)
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                        {hasPermission('ADD') && (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<AddIcon />}
                                onClick={handleOpenAdd}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                New Assignment
                            </Button>
                        )}
                        
                        {hasPermission('VIEW') && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<FilterIcon />}
                                onClick={handlefilterOptions}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                View Options
                            </Button>
                        )}
                        
                        {hasPermission('EXPORT') && (
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<GetApp />}
                                onClick={handleExportClick}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Export Data
                            </Button>
                        )}
                        
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<RefreshIcon />}
                            onClick={() => {
                                fetchAssignments();
                                fetchStatistics();
                                fetchTenants();
                                fetchAvailableProperties();
                            }}
                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                        >
                            Refresh
                        </Button>
                    </Box>

                    <Paper sx={{
                        width: '300px',
                        p: '2px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        borderRadius: '8px',
                        background: theme.palette.primary.light
                    }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search assignments..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: <Search sx={{ mr: 1, color: 'white' }} />,
                                sx: {
                                    '& fieldset': { border: 'none' },
                                    fontSize: '0.875rem',
                                    color: 'white',
                                    '& input': {
                                        color: 'white',
                                        '&::placeholder': {
                                            color: 'rgba(255, 255, 255, 0.7)',
                                            opacity: 1
                                        }
                                    }
                                }
                            }}
                            size="small"
                        />
                    </Paper>
                </Box>

                {/* Active Filters */}
                {(filters.assignment_status || filters.property_id || filters.tenant_id || 
                  filters.date_from || filters.date_to) && (
                    <Box sx={{ 
                        display: 'flex', 
                        gap: 1, 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        mt: 2,
                        pt: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider'
                    }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                            Active filters:
                        </Typography>
                        {filters.assignment_status && (
                            <Chip
                                label={`Status: ${getStatusText(filters.assignment_status)}`}
                                onDelete={() => setFilters(prev => ({ ...prev, assignment_status: '' }))}
                                color={getStatusColor(filters.assignment_status)}
                                variant="outlined"
                            />
                        )}
                        {filters.property_id && (
                            <Chip
                                label={`Property: ${properties.find(p => p.id.toString() === filters.property_id)?.property_name || filters.property_id}`}
                                onDelete={() => setFilters(prev => ({ ...prev, property_id: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.tenant_id && (
                            <Chip
                                label={`Tenant ID: ${filters.tenant_id}`}
                                onDelete={() => setFilters(prev => ({ ...prev, tenant_id: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.date_from && (
                            <Chip
                                label={`From: ${filters.date_from}`}
                                onDelete={() => setFilters(prev => ({ ...prev, date_from: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.date_to && (
                            <Chip
                                label={`To: ${filters.date_to}`}
                                onDelete={() => setFilters(prev => ({ ...prev, date_to: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        <Button
                            size="small"
                            onClick={clearFilters}
                            startIcon={<CloseIcon />}
                            sx={{ ml: 1 }}
                        >
                            Clear All
                        </Button>
                    </Box>
                )}
            </Paper>

            {/* Export Menu */}
            <Menu
                anchorEl={exportAnchorEl}
                open={Boolean(exportAnchorEl)}
                onClose={handleExportClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleExportExcel} sx={{ gap: 1 }}>
                    <TableChart fontSize="small" color="success" />
                    Export to Excel (.xlsx)
                </MenuItem>
                <MenuItem onClick={handleExportPDF} sx={{ gap: 1 }}>
                    <PictureAsPdf fontSize="small" color="error" />
                    Export to PDF (.pdf)
                </MenuItem>
            </Menu>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    '& th': {
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '0.95rem'
                                    }
                                }}>
                                    <TableCell>#</TableCell>
                                    <TableCell>Tenant</TableCell>
                                    <TableCell>Property</TableCell>
                                    <TableCell>Monthly Rent (UGX)</TableCell>
                                    <TableCell>Move-in Date</TableCell>
                                    <TableCell>Deposit</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((record, index) => {
                                    return (
                                        <TableRow
                                            key={record.id || index}
                                            hover
                                            sx={{
                                                '&:nth-of-type(odd)': {
                                                    backgroundColor: theme.palette.action.hover
                                                }
                                            }}
                                        >
                                            <TableCell>
                                                <Chip
                                                    label={page * rowsPerPage + index + 1}
                                                    color="primary"
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                        {record.tenant_name}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        {record.tenant_phone}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                    {record.property_name}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {record.property_address}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                                    {formatCurrency(record.agreed_rent_amount)}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {record.move_in_date}
                                            </TableCell>
                                            <TableCell>
                                                {record.security_deposit_paid ? (
                                                    <Tooltip title={`Paid: ${formatCurrency(record.deposit_amount)}`}>
                                                        <Chip
                                                            icon={<CheckCircle />}
                                                            label="Paid"
                                                            color="success"
                                                            size="small"
                                                        />
                                                    </Tooltip>
                                                ) : (
                                                    <Chip
                                                        icon={<Cancel />}
                                                        label="Not Paid"
                                                        color="error"
                                                        size="small"
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={getStatusIcon(record.assignment_status)}
                                                    label={getStatusText(record.assignment_status)}
                                                    color={getStatusColor(record.assignment_status)}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                {hasPermission('VIEW') && (
                                                    <Tooltip title="View Details">
                                                        <IconButton
                                                            edge="end"
                                                            onClick={() => handleOpenView(record)}
                                                            color="primary"
                                                        >
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {hasPermission('PRINT') && (
                                                    <Tooltip title="Print">
                                                        <IconButton
                                                            onClick={() => handlePrint(record)}
                                                            color="info"
                                                            size="small"
                                                        >
                                                            <Print />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {hasPermission('EDIT') && record.assignment_status === 'active' && (
                                                    <>
                                                        <Tooltip title="Edit">
                                                            <IconButton
                                                                edge="end"
                                                                onClick={() => handleOpenEdit(record)}
                                                                color="secondary"
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Terminate">
                                                            <IconButton
                                                                edge="end"
                                                                onClick={() => handleOpenTerminate(record)}
                                                                color="error"
                                                            >
                                                                <Gavel />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Mark Complete">
                                                            <IconButton
                                                                edge="end"
                                                                onClick={() => handleOpenComplete(record)}
                                                                color="info"
                                                            >
                                                                <CheckCircleOutlineOutlined />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}

                                                {hasPermission('DELETE') && (
                                                    <Tooltip title="Delete">
                                                        <IconButton
                                                            edge="end"
                                                            onClick={() => handleOpenDelete(record)}
                                                            color="error"
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ mt: 2 }}
                    />

                    {filteredData.length === 0 && (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            py: 8,
                            color: 'text.secondary'
                        }}>
                            <AssignmentInd sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h6">No assignments found</Typography>
                            <Typography variant="body2">Try adjusting your search query</Typography>
                        </Box>
                    )}
                </Paper>
            </motion.div>

            {/* Filter Options Dialog */}
            <Dialog
                open={filterOptions}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                onClose={handleCloseOptions}
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Filter Options</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<RefreshIcon />}
                            onClick={clearFilters}
                        >
                            Show All Assignments
                        </Button>

                        <Divider>OR</Divider>

                        <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
                            Filter Assignments
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Assignment Status</InputLabel>
                                    <Select
                                        name="assignment_status"
                                        value={filters.assignment_status}
                                        onChange={handleFilterChange}
                                        label="Assignment Status"
                                    >
                                        <MenuItem value="">All Status</MenuItem>
                                        {assignmentStatusOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Property</InputLabel>
                                    <Select
                                        name="property_id"
                                        value={filters.property_id}
                                        onChange={handleFilterChange}
                                        label="Property"
                                    >
                                        <MenuItem value="">All Properties</MenuItem>
                                        {properties.map((property) => (
                                            <MenuItem key={property.id} value={property.id}>
                                                {property.property_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Date From"
                                    name="date_from"
                                    type="date"
                                    value={filters.date_from}
                                    onChange={handleFilterChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Date To"
                                    name="date_to"
                                    type="date"
                                    value={filters.date_to}
                                    onChange={handleFilterChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseOptions} variant="contained">
                        Close
                    </Button>
                    <Button onClick={applyFilters} color="primary" variant="contained">
                        Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Assignment Dialog */}
            <Dialog
                open={openAdd}
                onClose={handleCloseAdd}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                scroll="paper"
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <b>{postStatus === "ADD" ? "New Property Assignment" : "Edit Assignment"}</b>
                </DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Box>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}>
                                    Assignment Information
                                </Typography>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth required>
                                    <InputLabel>Select Tenant *</InputLabel>
                                    <Select
                                        name="tenant_id"
                                        value={formData.tenant_id}
                                        onChange={handleInputChange}
                                        label="Select Tenant *"
                                    >
                                        <MenuItem value="">Select a tenant</MenuItem>
                                        {tenants.map((tenant) => (
                                            <MenuItem key={tenant.id} value={tenant.id}>
                                                {tenant.full_name} - {tenant.phone_number}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth required>
                                    <InputLabel>Select Property *</InputLabel>
                                    <Select
                                        name="property_id"
                                        value={formData.property_id}
                                        onChange={handleInputChange}
                                        label="Select Property *"
                                    >
                                        <MenuItem value="">Select a property</MenuItem>
                                        {availableProperties.map((prop) => (
                                            <MenuItem key={prop.id} value={prop.id}>
                                                {prop.property_name} - {prop.property_address}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Move-in Date *"
                                    name="move_in_date"
                                    type="date"
                                    value={formData.move_in_date}
                                    onChange={handleInputChange}
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CalendarToday />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid><br/>

                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1, mt: 2 }}>
                                    Financial Information
                                </Typography>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Agreed Rent Amount (UGX) *"
                                    name="agreed_rent_amount"
                                    type="number"
                                    value={formData.agreed_rent_amount}
                                    onChange={handleInputChange}
                                    required
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AttachMoney />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Deposit Amount (UGX)"
                                    name="deposit_amount"
                                    type="number"
                                    value={formData.deposit_amount}
                                    onChange={handleInputChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CreditCard />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="security_deposit_paid"
                                            checked={formData.security_deposit_paid}
                                            onChange={handleInputChange}
                                            color="primary"
                                        />
                                    }
                                    label="Security Deposit Paid"
                                />
                            </Grid><br/>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Assignment Status</InputLabel>
                                    <Select
                                        name="assignment_status"
                                        value={formData.assignment_status}
                                        onChange={handleInputChange}
                                        label="Assignment Status"
                                    >
                                        {assignmentStatusOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    {item.icon}
                                                    {item.name}
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Notes"
                                    name="notes"
                                    value={formData.notes}
                                    onChange={handleInputChange}
                                    multiline
                                    rows={4}
                                    placeholder="Additional information about the assignment..."
                                />
                            </Grid>
                        </Box>

                        <DialogActions sx={{ mt: 3, px: 0 }}>
                            <Button color="error" onClick={handleCloseAdd} variant="contained">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary" variant="contained">
                                {postStatus === "ADD" ? "Create Assignment" : "Update Assignment"}
                            </Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* View Dialog */}
            <Dialog
                open={openView}
                onClose={handleCloseView}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <b>Assignment Details</b>
                </DialogTitle>
                <DialogContent>
                    {selectedRecord && (
                        <Box>
                            <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} sx={{ mb: 2 }}>
                                <Tab label="Assignment Info" icon={<AssignmentInd />} iconPosition="start" />
                                <Tab label="Tenant Info" icon={<Person />} iconPosition="start" />
                                <Tab label="Property Info" icon={<Business />} iconPosition="start" />
                                <Tab label="History" icon={<History />} iconPosition="start" />
                            </Tabs>

                            {activeTab === 0 && (
                                <Box sx={{ p: 2 }}>
                                    <Box>
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" color="primary">
                                                    {selectedRecord.assignment_id}
                                                </Typography>
                                                <Chip
                                                    icon={getStatusIcon(selectedRecord.assignment_status)}
                                                    label={getStatusText(selectedRecord.assignment_status)}
                                                    color={getStatusColor(selectedRecord.assignment_status)}
                                                />
                                            </Box>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Move-in Date:</b> {selectedRecord.move_in_date}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Agreed Rent:</b> {formatCurrency(selectedRecord.agreed_rent_amount)}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Security Deposit:</b> {selectedRecord.security_deposit_paid ? 'Paid' : 'Not Paid'}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Deposit Amount:</b> {formatCurrency(selectedRecord.deposit_amount || 0)}</Typography>
                                        </Grid><br/>
                                        {selectedRecord.termination_date && (
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2"><b>Termination Date:</b> {selectedRecord.termination_date}</Typography>
                                            </Grid>
                                        )}
                                        <br/>
                                        {selectedRecord.termination_reason && (
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2"><b>Termination Reason:</b> {selectedRecord.termination_reason}</Typography>
                                            </Grid>
                                        )}
                                        <br/>
                                        {selectedRecord.notes && (
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2"><b>Notes:</b> {selectedRecord.notes}</Typography>
                                            </Grid>
                                        )}
                                    </Box>
                                </Box>
                            )}

                            {activeTab === 1 && (
                                <Box sx={{ p: 2 }}>
                                    <Box>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" color="primary">
                                                {selectedRecord.tenant_name}
                                            </Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Phone:</b> {selectedRecord.tenant_phone}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Email:</b> {selectedRecord.tenant_email || '-'}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2"><b>Emergency Contact:</b> {selectedRecord.emergency_contact_name || '-'}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2"><b>Emergency Phone:</b> {selectedRecord.emergency_contact_phone || '-'}</Typography>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}

                            {activeTab === 2 && (
                                <Box sx={{ p: 2 }}>
                                    <Box>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" color="primary">
                                                {selectedRecord.property_name}
                                            </Typography>
                                        </Grid><br/>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2"><b>Property Address:</b> {selectedRecord.property_address || '-'}</Typography>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}

                            {activeTab === 3 && (
                                <Box sx={{ p: 2 }}>
                                    {assignmentHistory.length === 0 ? (
                                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                                            No history records found
                                        </Typography>
                                    ) : (
                                        <Timeline position="alternate">
                                            {assignmentHistory.map((event, index) => (
                                                <TimelineItem key={index}>
                                                    <TimelineOppositeContent color="text.secondary">
                                                        {new Date(event.created_at).toLocaleDateString()}
                                                    </TimelineOppositeContent>
                                                    <TimelineSeparator>
                                                        <TimelineDot color={event.action_type === 'create' ? 'success' : 
                                                                          event.action_type === 'terminate' ? 'error' : 
                                                                          event.action_type === 'complete' ? 'info' : 'warning'}>
                                                            {event.action_type === 'create' ? <AddIcon /> : 
                                                             event.action_type === 'terminate' ? <Gavel /> : 
                                                             event.action_type === 'complete' ? <CheckCircleOutlineOutlined /> : <EditIcon />}
                                                        </TimelineDot>
                                                        {index < assignmentHistory.length - 1 && <TimelineConnector />}
                                                    </TimelineSeparator>
                                                    <TimelineContent>
                                                        <Paper elevation={2} sx={{ p: 2 }}>
                                                            <Typography variant="h6" component="span">
                                                                {event.title}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {event.description}
                                                            </Typography>
                                                            <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>
                                                                By: {event.performed_by_name || 'System'}
                                                            </Typography>
                                                        </Paper>
                                                    </TimelineContent>
                                                </TimelineItem>
                                            ))}
                                        </Timeline>
                                    )}
                                </Box>
                            )}

                            <Grid item xs={12}>
                                <Typography variant="h6" color="primary" gutterBottom sx={{ mt: 2 }}>
                                    System Information
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2"><b>Created Date:</b> {formatCreatedAtDate(selectedRecord.created_at)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2"><b>Last Updated:</b> {formatCreatedAtDate(selectedRecord.updated_at)}</Typography>
                            </Grid>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseView} variant="contained">
                        Close
                    </Button>
                    {hasPermission('PRINT') && selectedRecord && (
                        <Button onClick={() => handlePrint(selectedRecord)} color="info" variant="contained">
                            <Print sx={{ mr: 1 }} /> Print
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

            {/* Terminate Assignment Dialog */}
            <Dialog
                open={terminateDialogOpen}
                onClose={handleCloseTerminate}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Terminate Assignment</DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 2 }}>
                        <Typography variant="body1" gutterBottom>
                            Are you sure you want to terminate the assignment for <strong>{selectedRecord?.tenant_name}</strong>?
                        </Typography>
                        <Alert severity="warning" sx={{ mb: 2 }}>
                            This will mark the assignment as terminated and update the tenant status.
                        </Alert>
                        <TextField
                            fullWidth
                            label="Termination Reason *"
                            value={terminationReason}
                            onChange={(e) => setTerminationReason(e.target.value)}
                            multiline
                            rows={3}
                            required
                            placeholder="Please provide a reason for termination..."
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseTerminate} variant="contained">
                        Cancel
                    </Button>
                    <Button onClick={handleTerminateAssignment} color="warning" variant="contained">
                        Terminate Assignment
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Complete Assignment Dialog */}
            <Dialog
                open={completeDialogOpen}
                onClose={handleCloseComplete}
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Complete Assignment</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                        Are you sure you want to mark this assignment as completed for <strong>{selectedRecord?.tenant_name}</strong>?
                    </Typography>
                    <Alert severity="info">
                        This will mark the assignment as completed and update the property availability.
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseComplete} variant="contained">
                        Cancel
                    </Button>
                    <Button onClick={handleCompleteAssignment} color="primary" variant="contained">
                        Mark Complete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={openDelete}
                onClose={handleCloseDelete}
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Delete Assignment</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                        Are you sure you want to delete this assignment?
                    </Typography>
                    {selectedRecord && (
                        <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                            {selectedRecord.assignment_id}
                            <Box sx={{ mt: 1 }}>
                                <Chip
                                    icon={<Person />}
                                    label={selectedRecord.tenant_name}
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                />
                                <Chip
                                    icon={<Business />}
                                    label={selectedRecord.property_name}
                                    color="info"
                                    variant="outlined"
                                    size="small"
                                    sx={{ ml: 1 }}
                                />
                            </Box>
                        </Typography>
                    )}
                    <Typography variant="body2" color="error" sx={{ textAlign: 'center', mt: 2 }}>
                        Warning: This action cannot be undone!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseDelete} variant="contained">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained">
                        Confirm Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default AssignTenant;

